export default __webpack_public_path__ + "static/media/outlineCheck.73a73594.svg";